<template>
  <ul class="tab">
    <li>
      <FeedTabSelectButton
        type="all"
        :current-type="currentType"
        label="Tout"
        :count="feedStore.newFeedsCount"
        @select="(type) => emit('select', type)"
      />
    </li>
    <li>
      <FeedTabSelectButton
        type="self"
        :current-type="currentType"
        label="Mon Actu"
        :count="feedStore.newUserFeedsCount"
        @select="(type) => emit('select', type)"
      />
    </li>
    <li>
      <FeedTabSelectButton
        type="following"
        :current-type="currentType"
        label="L'actu de mes potes"
        :count="feedStore.newFollowingFeedsCount"
        @select="selectFriendsFeed"
      />
    </li>
  </ul>
</template>
<script setup lang="ts">
interface Props {
  currentType: 'all' | 'self' | 'following';
}
defineProps({
  currentType: null
});
const emit = defineEmits(["select"]);

const selectFriendsFeed = () => {
  useAppEventFriend().send(EventFriend.FriendFeedPageViewed);
  emit('select', 'following');
};

const feedStore = useFeedStore();
</script>
<style lang="scss" scoped>
.tab {
  display: flex;
  position: relative;
  justify-content: space-around;
  width: 100%;
  button {
    width: 100%;
    text-align: center;
    @include font('m', 600, 'secondary');
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.2rem;
    background-color: var(--color_secondary_lighter);
  }
}
</style>
